import React, { Component } from 'react';
import jQuery from 'jquery';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';


import Header from './../../Header';
import Relations from './../../Relation/Relations';
import RelationForm from './../../Relation/RelationForm';
import ErrorBoundary from '../ErrorBoundary';

class RelationsEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "relations" : [], 
            "relation" : {},
        };

        this.load = this.load.bind(this);
        this.loadRelation = this.loadRelation.bind(this);
        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);

        this.load(props.match.params.id);
    }


    load(id)
    {
        Promise.all([
            Core.Instance.Request(Core.Address+"Client/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"Relation/Client_id/"+id, null, "GET")
        ])
        .then((data) => {
            if(data[0] == null)
            {
                ErrorManager.Instance.Handle("Aucun client ne possède cet identifiant.");
                return;
            }
            this.setState({
                "client" : data[0],
                "relations" : data[1] != null ? data[1] : [] 
            });
        });
    }

    loadRelation(id)
    {
        Core.Instance.Request(Core.Address+"Relation/"+id, null, "GET")
        .then((data) => {
            if(data == null)
            {
                ErrorManager.Instance.Handle("Aucun avis ne possède cet identifiant.");
                return;
            }

            jQuery('#addRelationModal').modal('show');
            this.setState({
                "relation" : data 
            });
        });
    }

    handleRedux(event)
    {
        let relation = this.state.relation;
        relation[event.target.name] = event.target.value;
        this.setState({
            "relation" : relation
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.relation).length <= 0)
        {
            ErrorManager.Instance.Error("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let relation = this.state.relation;
        //relation.date = relation.date != null ? relation.date/1000 : null;
        relation.Client_id = this.state.client.id;
        let request = null;

        if(relation.id){
            request = Core.Instance.Request(Core.Address+"Relation/"+relation.id, relation, "PUT");
        }else{
            request = Core.Instance.Request(Core.Address+"Relation", relation, "POST");
        }
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.client.id, "Enregistrement d'une entrée relation client.");
        }).then(() => {
            ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            window.location.reload();
        });      
    }

    render()
    {
        document.title = "W-F: Relations liées "+this.state.client.name + " " +this.state.client.first_name;

        return (
            <ErrorBoundary>
                <Header buttons={ [
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Historique relation client</span>
                                        <span className="float-right" data-toggle="modal" data-target="#addRelationModal">
                                            <a href="#"><li className='fas fa-plus'></li> <u>Ajouter une relation</u></a>    
                                        </span>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Relations relations={ this.state.relations } editing={ true } loadRelation={ this.loadRelation } />
                                </div>
                            </div>
                        </div>
                    </div>
                    <RelationForm relation={ this.state.relation } onChange={ this.handleRedux } onSubmit={this.submit} />
                </div>
            </ErrorBoundary>
        );
    }
}
export default RelationsEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/Relation/RelationsEdit.js